import { getboardinglog } from "../../services/Reportservice";
import React, { useEffect, useState } from "react";
import Reportselect from "./Reportselect";
import Select from "react-select";
import { parse, format } from "date-fns";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { PiExportBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { getboardinglogexport } from "../../services/Reportservice";
import {
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";

const EmployeePassTable = ({ selectedemployee, checkgender }) => {
  const getRowStyle = (row) => {
    const rule = checkgender?.find((rule) => rule.when(row));
    return rule ? { backgroundColor: rule.style.backgroundColor } : {};
  };

  return (
    <div
      className="table-responsive"
      style={{ maxHeight: "63vh", overflowY: "auto" }}
    >
      {selectedemployee && selectedemployee.length > 0 ? (
        <table class="table fs-6 align-middle">
          <thead class="table-light custom-thead sticky-top">
            <tr>
              <th>Date</th>
              <th style={{ width: "90px" }}>Pass ID</th>
              <th>Name</th>
              <th>Stop</th>
            </tr>
          </thead>
          <tbody>
            {selectedemployee?.map((row, index) => (
              <tr
                key={index}
                style={getRowStyle(row)}
                className="cursor-pointer"
              >
                <td>
                  {row?.timestamp
                    ? format(new Date(row.timestamp), "MMMM dd, yyyy hh:mm a")
                    : "N/A"}
                </td>
                <td>{row?.pass_id || "N/A"}</td>
                <td>{row?.name || "N/A"}</td>
                <td>{row?.stop_name || "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center my-3">There are no records found.</div>
      )}
    </div>
  );
};

const BusTable = ({
  data,
  setSelectedEmployee,
  conditionalRowStyles,
  setSelectedRow,
  selectedRow,
}) => {
  const getRowStyle = (row) => {
    if (selectedRow?.bus_registration_number === row?.bus_registration_number) {
      return { backgroundColor: "#e3f2fd" }; // Light blue for selection
    }

    const rule = conditionalRowStyles?.find((rule) => rule.when(row));
    return rule ? { backgroundColor: rule.style.backgroundColor } : {};
  };

  return (
    <div
      className="table-responsive"
      style={{ maxHeight: "63vh", overflowY: "auto" }}
    >
      {data && data.length > 0 ? (
        <table class="table fs-6 align-middle">
          <thead class="table-light custom-thead sticky-top">
            <tr>
              <th>Bus Number</th>
              <th>Route</th>
              <th>Driver</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr
                key={idx}
                style={getRowStyle(row)}
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEmployee(row?.employees || []);
                  setSelectedRow(row);
                }}
              >
                <td>
                  <span
                    className="fw-semibold text-primary cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent row click
                      setSelectedEmployee(row?.employees || []);
                    }}
                  >
                    {row?.bus_registration_number || "N/A"}
                  </span>
                </td>
                <td>{row?.route?.route_name || "N/A"}</td>
                <td>{row?.driver || "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="my-3 text-center ">There are no records found.</div>
      )}
    </div>
  );
};
const Boardinglogreport = () => {
  const [loading, setLoading] = useState(false);
  const [excellLoading, setExcellLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const defaultOption = { value: "7_days", label: "Last 7 Days" };
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [employeedata, setEmployeedata] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedemployee, setSelectedEmployee] = useState([]);
  const [param, setParam] = useState({
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    query: "",
  });
  const conditionalRowStyles = [
    {
      when: (row) =>
        selectedRow &&
        row.bus_registration_number == selectedRow.bus_registration_number,
      style: {
        backgroundColor: "#cce5ff", // light blue
        color: "#004085",
        fontWeight: "bold",
      },
    },
  ];
  const getreport = () => {
    setEmployeedata([]);
    setLoading(true);
    getboardinglog(param)
      .then((res) => {
        setData(res?.data?.results);
        setSelectedEmployee(res?.data?.results[0]?.employees || []);
        setSelectedRow(res?.data?.results[0]);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getreport();
  }, [param]);

  const handleexport = () => {
    setExcellLoading(true);
    const newparam = { ...param, export: true };
    getboardinglogexport(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Boarding log.xlsx"; // set your desired filename
        a.click();
        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExcellLoading(false);
      });
  };
  const options = [
    { value: "yesterday", label: "Yesterday" },
    { value: "7_days", label: "Last 7 Days" },
    { value: "15_days", label: "Last 15 Days" },
    { value: "30_days", label: "Last 30 Days" },
    { value: "last_month", label: "Last Month" },
    { value: "3_months", label: "Last 3 Months" },
    { value: "custom", label: "Custom Date" },
  ];
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
    });
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
    }));
  };
  const checkgender = [
    {
      when: (row) => row.gender?.toLowerCase() === "female", // Adjust based on your key
      style: {
        backgroundColor: "#ffe6f0", // Light pink or any color you like
        color: "#000", // Text color
      },
    },
  ];
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Boarding History
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              onClick={handleexport}
              // style={{ height: "38px" }}
              disabled={excellLoading || data.length === 0}
            >
              {" "}
              {excellLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="flex-fill flex-md-grow-0">
            <small>Search</small>
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <small>Select Date</small>
                {/* <DatePicker
              onChange={handleDateChange}
              autoHide={true}
              todayBtn={true}
              clearBtn={true}
              format="yyyy/mm/dd"
              value={{
                startDate: param.start_date,
                endDate: param.end_date,
              }}
            /> */}
                {/* <FaCalendarAlt className="me-2" /> */}
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                  popperProps={{
                    modifiers: [
                      {
                        name: "zIndex",
                        enabled: true,
                        phase: "beforeWrite",
                        fn({ state }) {
                          state.styles.popper.zIndex = 999;
                        },
                      },
                    ],
                  }}
                />
              </div>
            )}
            <div className="flex-fill flex-md-grow-0">
              <small>Select Period</small>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select Period"
                className="react-select"
                classNamePrefix="select"
                value={selectedOption}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-3">{error}</div>
          ) : (
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="card" style={{ height: "63vh" }}>
                  <BusTable
                    data={data}
                    setSelectedEmployee={setSelectedEmployee}
                    conditionalRowStyles={conditionalRowStyles}
                    setSelectedRow={setSelectedRow}
                    selectedRow={selectedRow}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="card" style={{ height: "63vh" }}>
                  <EmployeePassTable
                    selectedemployee={selectedemployee}
                    checkgender={checkgender}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Boardinglogreport;
